import { gql } from "graphql-tag"

const tmdbQuery = gql`
  type Query {
    findTMDB(imdbId: String!): [TMDBSearchResult]
    searchTMDB(searchTMDBInput: SearchTMDBInput!): [TMDBSearchResult]
  }

  input SearchTMDBInput {
    query: String!
    type: SearchType
    page: Int
  }
`

export default tmdbQuery
